import { render } from "./Requisitions.vue?vue&type=template&id=741fa212&scoped=true"
import script from "./Requisitions.vue?vue&type=script&lang=js"
export * from "./Requisitions.vue?vue&type=script&lang=js"

import "./Requisitions.vue?vue&type=style&index=0&id=741fa212&lang=css"
import "./Requisitions.vue?vue&type=style&index=1&id=741fa212&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741fa212"]])

export default __exports__